// @flow
import React, { memo } from 'react'
import striptags from 'striptags'
import classNames from 'classnames'

import LoadableHtmlRender from './LoadableHtmlRender'

// config
import { config } from '../../Config/ConfigLoader'

type FieldLabelProps = {
  allowedTags?: Array<string>,
  className?: string,
  id: string,
  isRequired?: boolean,
  label: string,
  labelValue?: string,
  wrapMode?: boolean,
}

const FieldLabel = (props: FieldLabelProps) => {
  let label = `${striptags(props.label, props.allowedTags || config.getConfig('allowedHtmlTags.FieldLabel'))}`
  if (typeof props.labelValue === 'string' && props.labelValue !== '') {
    label = label.replace('{value}', props.labelValue)
  }
  const isHtml = label.includes('<') && label.includes('>')

  return (
    <label
      className={classNames([props.className || `mb-0 mr-4 ${props.wrapMode ? '' : 'text-nowrap'} font-weight-bold`])}
      htmlFor={props.id}
    >
      {isHtml
        ? <LoadableHtmlRender label={label} />
        : label
      }
      {props.isRequired &&
      <span className='text-danger'> *</span>
      }
    </label>
  )
}

export default memo(FieldLabel)
